import React from 'react';

const SharingDoneModal = ({ show, onHide }) => {

    return (
        <div className="mdl backdrop-blur-[30px]" style={{ display: show ? 'flex' : 'none' }}>
            <div className="mdl-dia">
                <div className="mdl-tit">DONE!</div>
                <div className="mdl-alert">
                    <p>THANK YOU FOR USING DESIGNER</p>
                    <p className="mdl-alert-msg">Check your e-mail to get your design package.</p>
                </div>
                <button className="mdl-btn primary" type="button" onClick={() => {
                    onHide(true);
                }}>
                    CLOSE
                </button>
            </div>
        </div>
    );
};

export default SharingDoneModal